
import { BaseModulePublicApi, addAuthToHeader } from "../../base/BaseModulePublicApi";

export class PublicShopOrdersApi extends BaseModulePublicApi {
  basePath = 'shop/orders';


  async create(cart_id: number, data: any, headers: any, configOptions?: any) {
    console.log('create', `/front/${this.domain}/${this.basePath}/${cart_id}`)
    const response = await this.axiosInstance!.post(`/front/${this.domain}/${this.basePath}/${cart_id}`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });

    if (response.status === 201) {
      return response.data;
    }
  };
  
  // PAYPAL
  async createOrder(data: any, headers: any, configOptions?: any) {
    console.log('create', `/front/${this.domain}/${this.basePath}/checkout/create_order`)
    const response = await this.axiosInstance!.post(`/front/${this.domain}/${this.basePath}/checkout/create_order`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });

    if (response.status === 201) {
      return response.data;
    }
  };

  // PAYPAL
  async aprove_order_payment(order_id: string, data: any, headers: any, configOptions?: any) {
    console.log('create', `/front/${this.domain}/${this.basePath}/checkout/${order_id}/aprove_order_payment`)
    const response = await this.axiosInstance!.post(`/front/${this.domain}/${this.basePath}/checkout/${order_id}/aprove_order_payment`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });

    if (response.status === 201) {
      return response.data;
    }
  };

};
